export default function Refunds() {
  return (
    <main className="relative py-16 bg-gray-900 overflow-hidden">
      <section className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
        <section
          className="relative h-full text-lg max-w-prose mx-auto"
          aria-hidden="true"
        >
          <svg
            className="absolute top-12 left-full transform translate-x-32"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
            />
          </svg>
          <svg
            className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
            />
          </svg>
          <svg
            className="absolute bottom-12 left-full transform translate-x-32"
            width={404}
            height={384}
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="d3eb07ae-5182-43e6-857d-35c643af9034"
                x={0}
                y={0}
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x={0}
                  y={0}
                  width={4}
                  height={4}
                  className="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width={404}
              height={384}
              fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
            />
          </svg>
        </section>
      </section>
      <section className="relative px-4 sm:px-6 lg:px-8">
        <section className="text-lg max-w-prose mx-auto">
          <h2>
            <span className="block text-base text-center text-[color:var(--primary-font-color)] font-semibold tracking-wide uppercase">
              Legal
            </span>
            <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
              NewSocial Refund Policy
            </span>
          </h2>
          <p className="mt-8 text-lg text-gray-500">This Refund Policy ("Policy") outlines the terms and conditions for requesting a refund for the Instagram growth services provided by NewSocial ("NewSocial," "we," "our," or "us"). By using our services, you ("you," "your," or "user") agree to comply with this Policy regarding refund requests.</p>
          <h3 className="text-lg text-gray-500">1. Eligibility for Refunds:</h3>
          <p className="text-lg text-gray-500">Refund requests will be considered under the following circumstances:</p>
          <ul className="text-lg text-gray-500">
            <li>If our services fail to deliver the results as specified in your chosen Growth Plan.</li>
            <li>If you experience technical issues preventing you from accessing our services.</li>
            <li>If you have mistakenly been charged for services you did not receive.</li>
          </ul>
          <h3 className="text-lg text-gray-500">2. Refund Request Process:</h3>
          <p className="text-lg text-gray-500">To request a refund, you must:</p>
          <ul className="text-lg text-gray-500">
            <li>Contact our customer support team at support@NewSocial.com within 30 days of your purchase.</li>
            <li>Provide details about the reason for your refund request and any relevant supporting documentation.</li>
            <li>Allow our team sufficient time to review your request and investigate the matter.</li>
          </ul>
          <h3 className="text-lg text-gray-500">3. Refund Decisions:</h3>
          <p className="text-lg text-gray-500">Refund decisions will be made at the discretion of NewSocial, taking into account the validity of the refund request and whether the refund eligibility criteria have been met. We reserve the right to approve or deny refund requests based on the circumstances of each case.</p>
          <h3 className="text-lg text-gray-500">4. Refund Method:</h3>
          <p className="text-lg text-gray-500">If your refund request is approved, the refund will be issued using the original payment method used for the purchase. Please note that the processing time for refunds may vary depending on the payment provider.</p>
          <h3 className="text-lg text-gray-500">5. Non-Refundable Items:</h3>
          <p className="text-lg text-gray-500">The following items are non-refundable:</p>
          <ul className="text-lg text-gray-500">
            <li>Refunds requested beyond 30 days from the date of purchase.</li>
            <li>Refunds requested due to changes in personal circumstances or preferences.</li>
            <li>Refunds requested for reasons not covered under the refund eligibility criteria.</li>
          </ul>
          <h3 className="text-lg text-gray-500">6. Changes to the Refund Policy:</h3>
          <p className="text-lg text-gray-500">We reserve the right to update or modify this Refund Policy at any time without prior notice. Your continued use of our services after any changes to the Policy constitutes your acceptance of the revised terms.</p>
          <h3 className="text-lg text-gray-500">7. Contact Us:</h3>
          <p className="text-lg text-gray-500">If you have any questions or concerns regarding this Refund Policy or our services, please contact us at support@NewSocial.com.</p>
          <p className="text-lg text-gray-500">By using NewSocial's services, you acknowledge that you have read, understood, and agree to this Refund Policy.</p>
        </section>
      </section>
    </main>
  );
}
